import { Link, useLocation } from "react-router-dom";
import { Flame, ChevronRight, FileText } from "lucide-react";
import AppHeader from "@/components/AppHeader";
import { GAS_FORM_LIST } from "@/config/gasFormConfigs";

export default function GasSafeSelectPage() {
  const location = useLocation();

  // Include the standalone boiler commissioning checklist
  const allForms = [
    { id: "boiler-commissioning", title: "Gas Boiler Commissioning Checklist", description: "Benchmark commissioning checklist with controls, readings & compliance", route: "/certificates/gas-safe/boiler-commissioning" },
    ...GAS_FORM_LIST.map((f) => ({ ...f, route: `/certificates/gas-safe/${f.id}` })),
  ];

  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--bg-page)' }} data-testid="gas-safe-select-page">
      <AppHeader />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex items-center gap-3 mb-6">
          <Flame className="w-6 h-6 text-[#EF4444]" />
          <div>
            <h1 className="text-2xl font-bold tracking-tight" style={{ fontFamily: 'Outfit, sans-serif' }}>Gas Safe Documents</h1>
            <p className="text-sm mt-1" style={{ color: 'var(--text-secondary)' }}>Select a document type to create</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {allForms.map((form) => (
            <Link key={form.id} to={form.route} data-testid={`gas-select-${form.id}`}
              className="brutalist-card p-4 flex items-center gap-3 hover:border-[#EF4444] transition-colors group">
              <div className="w-10 h-10 bg-[#EF4444] flex items-center justify-center border-2 flex-shrink-0" style={{ borderColor: 'var(--border-main)' }}>
                <FileText className="w-5 h-5 text-white" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-bold truncate" style={{ fontFamily: 'Outfit, sans-serif' }}>{form.title}</p>
                <p className="text-xs truncate" style={{ color: 'var(--text-muted)' }}>{form.description}</p>
              </div>
              <ChevronRight className="w-5 h-5 flex-shrink-0 text-[#B8B9BD] group-hover:text-[#EF4444] transition-colors" />
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
